import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const Error404Page = lazy(() => import('./Error404Page'));
const Error500Page = lazy(() => import('./Error500Page'));
const Error403Page = lazy(() => import('./Error403Page'));

const errorPagesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    /**
     * "You are not allowed to visit this page".
     * `auth: null` means every role can render it - without that it would
     * inherit settingsConfig.defaultAuth, which excludes the agency and
     * provider roles and would make the 403 redirect loop.
     */
    {
      path: 'pages/error/403',
      element: <Error403Page />,
      auth: null,
    },
    {
      path: 'pages/error',
      children: [
        {
          path: '',
          element: <Navigate to="404" />,
        },
        {
          path: '404',
          element: <Error404Page />,
        },
        {
          path: '500',
          element: <Error500Page />,
        },
      ],
    },
  ],
};

export default errorPagesConfig;
